import React from "react"
import {Typography} from "@mui/material"
import {formatTextTestIds} from "@next/utils"
import {TextModel} from "models/Text"
import {SearchApiRequestTypes} from "../../config/constants"
import Connect from "./connect"
import {Italic, List, ListItem, NoResultsText, SuggestionsText} from "./components"

interface NoResultsProps {
    searchTerm: string | null
    text: TextModel
    type: SearchApiRequestTypes
}

export const NoResults = ({searchTerm, text, type}: NoResultsProps) => {
    const keywordSearch = type === SearchApiRequestTypes.Keyword
    const noResults = keywordSearch ? text.pages.noResults : text.pages.categoryNoResults
    return (
        <>
            <NoResultsText data-testid={formatTextTestIds(`plp-no-results-header`)} component="h1" variant="body1">
                {noResults.header}{" "}
                {keywordSearch && (
                    <Italic>
                        &quot;
                        {searchTerm}
                        &quot;
                    </Italic>
                )}
            </NoResultsText>

            <SuggestionsText variant="body1">{noResults.subHeader}</SuggestionsText>

            <Typography variant="body1" gutterBottom component="span">
                <List>
                    {Object.keys(noResults.body).map(item => (
                        <ListItem key={item}>{noResults.body[item]}</ListItem>
                    ))}
                </List>
            </Typography>
        </>
    )
}

export default Connect(NoResults)
